var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M4.2 13.7L13.7 8 4.2 2.3"}));
}

Play.defaultProps = {"width":"50","height":"50","viewBox":"0 0 16 16"};

module.exports = Play;

Play.default = Play;
